import React from "react";
import { IconCheckmark } from "@purpur/icon/checkmark";
import { Paragraph } from "@purpur/paragraph";
import c from "classnames/bind";

import styles from "./card-feature-list.module.scss";

const cx = c.bind(styles);

export type CardFeatureListProps = {
  /**
   * Use this to set a testid on the feature list
   */
  ["data-testid"]?: string;
  /**
   * This is the feature list where each entry is preceded by a checkmark. If the feature list provided is falsy or empty nothing will be rendered.
   */
  listItems?: string[];
};

const rootClassName = "purpur-card-feature-list";

export const CardFeatureList = ({
  ["data-testid"]: dataTestId = "purpur-card-feature-list",
  listItems,
}: CardFeatureListProps) => {
  return listItems && listItems.length > 0 ? (
    <ul className={cx(rootClassName)} data-testid={dataTestId}>
      {listItems.map((listItem: string) => (
        <li
          className={cx(`${rootClassName}__list-item`)}
          data-testid={`${dataTestId}-item`}
          key={listItem}
        >
          <IconCheckmark size="xs" className={cx(`${rootClassName}__icon`)} />
          <Paragraph>{listItem}</Paragraph>
        </li>
      ))}
    </ul>
  ) : null;
};
